(function () {
  var STORAGE_KEY = 'cellfy_alerts_seen_signature';

  function init() {
    // Pode haver dois gatilhos: o da barra inferior (mobile, com os dados
    // reais — quantidade e assinatura dos alertas cadastrados) e o do
    // header (desktop), que só espelha o mesmo estado.
    var triggers = document.querySelectorAll('[data-cellfy-alerts-trigger]');
    if (!triggers.length) return;

    var dataSource = Array.prototype.find.call(triggers, function (el) {
      return el.dataset.alertSignature;
    });
    if (!dataSource || dataSource.dataset.cellfyInit === 'true') return;

    var signature = dataSource.dataset.alertSignature || '';
    var count = dataSource.dataset.alertCount || '0';

    function getSeenSignature() {
      try {
        return window.localStorage.getItem(STORAGE_KEY) || '';
      } catch (e) {
        return '';
      }
    }

    function setAllBadges(display) {
      triggers.forEach(function (trigger) {
        var badge = trigger.querySelector('[data-cellfy-alerts-badge]');
        if (!badge) return;
        if (display === 'flex' && badge.textContent === '') {
          badge.textContent = count;
        }
        badge.style.display = display;
      });
    }

    function markAsSeen() {
      try {
        window.localStorage.setItem(STORAGE_KEY, signature);
      } catch (e) {
        // localStorage indisponível (modo privado, etc.) — sem problema,
        // o alerta só vai reaparecer a cada visita nesse caso.
      }
      setAllBadges('none');
    }

    // Mostra o número só se essa combinação de alertas ainda não foi vista
    // (se o conteúdo mudar — um alerta novo, por exemplo — a assinatura
    // muda e o contador volta a aparecer).
    if (count !== '0' && getSeenSignature() !== signature) {
      setAllBadges('flex');
    }

    triggers.forEach(function (trigger) {
      trigger.dataset.cellfyInit = 'true';
      trigger.addEventListener('click', markAsSeen);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();